// extracted by mini-css-extract-plugin
export default {"title":"CustomerManagement_title__y+Ahg"};